module.exports = __webpack_public_path__ + "media/icons/arrow-up-eda6c00439c947887868669abe2fa5ac.svg";